import Vue from 'vue'

const Events = new Vue()

export const confirm = e =>
  new Promise(resolve => Events.$emit('confirm', e, res => resolve(res)))

export const openImageViewer = e => Events.$emit('imageViewer', e)

export const openVideoViewer = e => Events.$emit('videoViewer', e)

export const openPdfViewer = e => Events.$emit('pdfViewer', e)

export const notify = e => Events.$emit('notification', e)

export default Events
